import { render } from "./Category-help-center-modal.vue?vue&type=template&id=3d0190a8&scoped=true"
import script from "./Category-help-center-modal.vue?vue&type=script&lang=js"
export * from "./Category-help-center-modal.vue?vue&type=script&lang=js"

import "./Category-help-center-modal.vue?vue&type=style&index=0&id=3d0190a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0190a8"]])

export default __exports__